
export default {
  placeDetails: {
    layer: 'Camada',
    lat: 'Lat.',
    lon: 'Lon.',
    notAvailable: 'Não disponível',
    placeDetails: 'Detalhes do local',
    placeName: 'Nome',
    latlngCopied: 'Latitude e longitude copiadas',
    lnglatCopied: 'Longitude e latitude copiadas',
    copyLatlng: 'Copiar no formato latitude,longitude',
    copyLnglat: 'Copiar no formato longitude,latitude',
    satelliteView: 'Vista de satélite'
  }
}
